/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MergedIntoHistoryEntry } from './MergedIntoHistoryEntry';
import {
    MergedIntoHistoryEntryFromJSON,
    MergedIntoHistoryEntryFromJSONTyped,
    MergedIntoHistoryEntryToJSON,
    MergedIntoHistoryEntryToJSONTyped,
} from './MergedIntoHistoryEntry';

/**
 * 
 * @export
 * @interface GetSourceMergedIntoHistory200Response
 */
export interface GetSourceMergedIntoHistory200Response {
    /**
     * 
     */
    data: Array<MergedIntoHistoryEntry>;
}

/**
 * Check if a given object implements the GetSourceMergedIntoHistory200Response interface.
 */
export function instanceOfGetSourceMergedIntoHistory200Response(value: object): value is GetSourceMergedIntoHistory200Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function GetSourceMergedIntoHistory200ResponseFromJSON(json: any): GetSourceMergedIntoHistory200Response {
    return GetSourceMergedIntoHistory200ResponseFromJSONTyped(json, false);
}

export function GetSourceMergedIntoHistory200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSourceMergedIntoHistory200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(MergedIntoHistoryEntryFromJSON)),
    };
}

export function GetSourceMergedIntoHistory200ResponseToJSON(json: any): GetSourceMergedIntoHistory200Response {
    return GetSourceMergedIntoHistory200ResponseToJSONTyped(json, false);
}

export function GetSourceMergedIntoHistory200ResponseToJSONTyped(value?: GetSourceMergedIntoHistory200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(MergedIntoHistoryEntryToJSON)),
    };
}

